<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "ranteiden_huolto";
    let title = "Ranteiden liikkuvuus ja huolto";
    let author = "Petteri";
    let blogDate = "1.2.2015";
    let titlePic = "ranne.jpg";
    let firstPara = "Ärtyneet ja kipeät ranteet vaivaavat nykyisin yhä useampaa ihmistä. Vaiva on yleistynyt samalla kun työnkuva on muuttunut enemmän paikallaan nöpöttämiseksi hiiren tai muun laitteen parissa. Lue tästä, mitä voit itse tehdä ranteidesi hyväksi ettei tilanne pahene ja kipu riistäytyy hallinnasta.";
</script>

<!-- Yhteenveto (etusivu ja blogitesktisivu) -->
{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

<!-- Vasinainen artikkeli -->
{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <!-- <p>{firstPara}</p> -->

            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>
               
            
            <p>Ärtyneet ja kipeät ranteet vaivaavat nykyisin yhä useampaa ihmistä. Vaiva on yleistynyt samalla kun ihmisen työnkuva on muuttunut enemmän paikallaan nöpöttämiseksi hiiren tai muun laitteen parissa. Tässä artikkelissa ja lopussa olevassa videossa käyme läpi harjoitteita, joita kannattaa tehdä ennen, kun homma riistäytyy hallinnasta. Valmiiksi kipeillä ranteilla harjoituksia ei kannata tehdä.</p>

            <p>Oireita on toki myös havaittavissa rakennusalalla, jossa työntekijä joutuu pitelemään käsissään täriseviä laitteita ja käyttämään 
            rannelihaksiaan staattisesti. Ranteen hermot ovat pinteessä ja puutumista sekä jumitiloja alkaa esiintyä. 
            Lopulta puutuminen ja kipuilu voi tuntua aina sormista niskaan asti. Vielä ei keltainen lehdistö ole julkaissut tutkimusta, 
            että jumiutuneet ranteet tappaa, mutta ainakin jumissa olevilla ranteilla saa elämästään hankalampaa, kuin sen tarvitsisi olla. </p>


            <h4>Miksi rannejumppaa tarvitaan?</h4>

            <p>Riittävä liikkuvuus ranteissa suojaa vammoilta ja mahdollistaa paremman suoritustekniikan. 
            Esimerkiksi etukyykyssä hyvä ranteiden liikkuvuus mahdollistaa tasapainosemman asennon levytangolle, 
            mikä heijastuu koko kroppaan aina polvia ja nilkkoja myöten.</p>

            <p>Usein kehonpainoilua tai voimistelua harrastava urheilija osaa itse pitää ranteensa kunnossa kuin itsestään,
            sillä liikkuvia ranteita tarvitaan lähes joka liikkeessä. Muiden lajien harrastajalle ei välttämättä tule 
            mieleen ranteiden liikkuvuuden merkitys. Kaatuessaan lumilautailija ottaa kaatumisen vastaan yleensä 
            kädellään. Huonossa asennossa vastaanotettu kaatuminen venähdyttää jäykän ranteen helpommin kuin vetreän. 
            Myös salibandyssä ranne on tärkeässä roolissa. Pallo on kevyt, ranne on jännityksessä ja liikkeet pieniä. 
            Ranne ei juuri käy ääriasennoissa, muuta kuin äärimmäisissä kontaktitilanteissa minkä jälkeen ranne hyvin 
            usein alkaakin ärtymään eikä enää kestä normaalia pallotyöskentelyä. Ärtyneen ranteen takia jää äkkiä 
            useammatkin turnaukset vaihtopenkkiä kulutellen.</p>
            
            <p>Mutta miksi sitten vasemman jalan villasukkaa kutova Pirkko tarvitsee rannejumppaa? Neulominen, hiirellä 
            näppäily ja kynällä kirjoittelu luo ranteeseen sekä pienen paineen että liikkeen. Näissä liikkeissä 
            ranteessa on staattinen paine, joka pitkään toistuessaan kuormittaa rannetta ja voi johtaa rasitusvammoihin. 
            Rasitus etenee tulehdukseksi ja tulehdus etenee isompiin lihaksiin ranteen seudulla. Tuloksena on ärtynyt,
            hyvin rasittunut ja taukoa tarvitseva käsi, jolla ei saa edes leipää leikattua ilman kipua.</p>
            
            <h4>Liike on lääke</h4>
            
            <p>Mikä siis avuksi? Neulomista ei voi lopettaa sillä myös vasemman jalan villasukka on saatava valmiiksi? 
            Liike on lääke sanotaan ja se liike lähtee sinusta! Toimistotyöläisille on nykyisin alettu jo 
            toitottaa hyvällä menestyksellä, että näytön edessä ei kannata kyhjöttää liian pitkiä aikoja. 
            Kannattaa siis pitää aika ajoin taukojumppia ja hyödyntää nämä tauot aukomalla kroppaa laajoilla 
            liikerajoilla. Siinä samalla kannattaa pyöritellä ranteet “auki” käymällä ranteella kaikki ilmansuunnat 
            läpi.</p>

            <iframe style="max-width: 100%" width="600" height="343" src="https://www.youtube.com/embed/oAqJZUmulS0" title="Ranteiden liikkuvuus ja huolto" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            
            <p>Tässä on video perusteellisesta rannejumpasta. Koko jumppaa ei työpäivän aikana tarvitse 
            tehdä mutta tee ainakin nämä:</p>
            <ol>
                <li>Nouse seisomaan ja pyörittele ensin käsiä laajassa kaaressa ympäri, jotta verenkierto vahvistuisi hartioista lähtien. Tämän jälkeen ojenna kätesi eteen, ojenna ranne ja pumppaa sormia nyrkkiin ja auki (videon kohta 00:25). Toista 10-20 kertaa.</li>
                <li>Koukista ranne toiseen ääriasentoon ja toista sama ranteiden pumppailu. Toista 10-20 kertaa. Nyt pitäis tuntua jo, että veri virtaa sormissa paremmin.</li>
                <li>Voit vielä vielä vahvistetun venyttelyn tarttumalla toisella kädellä toisen käden sormista kiinni ja pitää hetken kättä venytyksessä kädet suorana (videon kohta 03:05)</li>
                <li>Laita vielä käsi nyrkkiin ja taivuta toisella kädellä nyrkissä olevan käden koko rannetta peukalon suuntaan (05:00)</li>
            </ol>
                
            <p><em>“Ota löysin rantein. Älä jännitä.”</em></p>
            <p>Kannattaa siis työkiireiden lomassa pysähtyä 
            aika-ajoin pyörittelemään olkapäitä, sekä lantiota ja ranteita. Jos ranteessasi on jo kipuja ja 
            pelkkä ajatuskin venyttelystä alkaa vihlomaan, konsultoi lääkäriä mitä asian kanssa voisi tehdä. 
            Tässä tapauksessa voi olla järkevintä aloittaa hoito kannattaa levolla ja pohtia, mikä on juurisyy kivulle. 
            Vasta kun tulehdus on rauhoittunut, voidaan alkaa huoltamaan, vahvistamaan ja lisäämään kohdenivelen liikelaajuuksia.</p>

            <p>-Petteri</p>

        </article>

        <section class="container">
            <h2>Lue seuraavaksi</h2>
            <div class="row">
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='2022-09-11_otevoima' title='Otteen ja puristusvoiman vahvistaminen' titlePic='ranne.jpg' blogDate='' firstPara='Hyvästä puristusvoimasta on hyötyä niin kuntosalilla kuin kotitöissä. Lue tästä vinkit otevoiman kehittämiseen.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='nilkan-liikkuvuus-ja-huolto-osa1' title='Nilkan liikkuvuus ja huolto' titlePic='nilkat.jpg' blogDate='' firstPara='Levytangolla tehtävistä kyykkyliikkeistä etu- ja takakyykky ovat ne tunnetuimmat ja tehokkaimmat versiot. Olen viimeisinä vuosina yrittänyt tehdä selkäni vuoksi enemmän etukyykkyä kuin takakyykkyä, sillä etukyykky on selälle kevyempi vaihtoehto.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='vastuskuminauhat_6_vinkkia' title='6 vinkkiä vastuskuminauhojen hyödyntämiseen' titlePic='2014/etunojapunnerrus2.jpg' blogDate='' firstPara='Vastuskuminauhat ovat hauska ja tehokas tapa tuoda monipuolisuutta ja vaihtelua harjoitteluun. Lue tästä vinkit vaskuskuminauhojen hyödyntämiseen treeneissä.'></BlogSummary>
                </article>
            </div>
        </section>

    </div>
{/if}

<style>


</style>
